import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Box,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import logo from "../../image/catalog/logonew.jpg";
import "./Sidebar.css";

const Sidebar = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  return (
    <div className="container">
      <div className="row">
        <IconButton
          className="sidebar-toggle"
          onClick={handleDrawerOpen}
          aria-label="Toggle Sidebar"
        >
          <DashboardIcon />
        </IconButton>
        <Drawer
          className="sidebar-drawer"
          anchor="left"
          open={openDrawer}
          onClose={handleDrawerClose}
        >
          <div className="sidebar-logo">
            <img
              src={logo}
              alt="logo"
              style={{ width: "200px", height: "80px" }}
            />
          </div>
          <List className="sidebar-menu">
            <ListItem button component={Link} to="/retailerdashboard">
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="My Profile" />
            </ListItem>
            <ListItem button component={Link} to="/orderlist">
              <ListItemIcon>
                <i className="menu-icon tf-icons bx bx-box"></i>
              </ListItemIcon>
              <ListItemText primary="Orders" />
            </ListItem>
            <ListItem button component={Link} to="/retproducts">
              <ListItemIcon>
                <i className="menu-icon tf-icons bx bx-box"></i>
              </ListItemIcon>
              <ListItemText primary="Return" />
            </ListItem>
          </List>
        </Drawer>
      </div>
    </div>
  );
};

export default Sidebar;
